import styled from '@emotion/styled';

export const UserAccessPermissionsContainer = styled.div`
  margin-top: 32px;
  max-width: 70%;
`;
